// @flow
import Bottle from 'bottlejs'

const ioc = new Bottle()

export { ioc }
